import { Button } from '@synoptic/ui-kit/button/button.js';
import { OpenNewWidnowIcon } from '@synoptic/ui-kit/icons/react/open-new-widnow.js';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { Spinner } from '@synoptic/ui-kit/spinner/spinner.js';
import { useCallbackRef } from '@synoptic/ui-kit/utils/use-callback-ref.js';
import { Wrap } from '@synoptic/ui-kit/wrap.js';
import { useEffect } from 'react';
import {
  pendingCryptoPaymentModalActionRow,
  pendingCryptoPaymentModalContent,
  pendingCryptoPaymentModalIcon,
} from './pending-crypto-payment-modal.css';

export const PendingCryptoPaymentModal = ({
  onCancel,
  invoiceUrl,
  message,
}: {
  onCancel: () => void;
  invoiceUrl?: string | null;
  message?: string;
}) => {
  const onCancelCb = useCallbackRef(onCancel);

  useEffect(() => {
    return onCancelCb;
  }, [onCancelCb]);

  return (
    <ModalRoot open>
      <ModalContent>
        <ModalHeader withoutCloseIcon>
          <ModalTitle>Waiting for Payment</ModalTitle>
        </ModalHeader>

        <div className={pendingCryptoPaymentModalContent}>
          {message}
          <Spinner size={72} className={pendingCryptoPaymentModalIcon} />
          <div className={pendingCryptoPaymentModalActionRow}>
            <Button variant="ghost" size="medium" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              startIcon={<OpenNewWidnowIcon />}
              variant="primary"
              size="medium"
              disabled={!invoiceUrl}
              asChild={Boolean(invoiceUrl)}
            >
              <Wrap
                with="a"
                href={invoiceUrl!}
                if={Boolean(invoiceUrl)}
                target="_blank"
              >
                Complete Payment
              </Wrap>
            </Button>
          </div>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
